<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Ajouter une activité"
      [updateLabel]="form.get('label').value"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <base-form-input label="Libellé" controlName="label"></base-form-input>

      <base-form-input
        label="Type d'activité"
        type="autocomplete"
        controlName="activityType"
        [items$]="activityTypeItem"
        displayProperty="label"
        (autocompleteChange)="autocompleteActivityTypeChange($event)"
      ></base-form-input>

      <ng-container *ngIf="establishmentType !== EstablishmentTypeEnum.SUPPORT_FUNCTION">
        <base-form-input
          label="Typologie des résidents"
          type="autocomplete"
          controlName="publicType"
          [items$]="publicTypeItem"
          (autocompleteChange)="autocompletePublicTypeChange($event)"
          displayProperty="label"
        ></base-form-input>
      </ng-container>
      <base-form-input label="Pourcentage" type="number" controlName="percent"></base-form-input>

      <ng-container *ngIf="establishmentType !== EstablishmentTypeEnum.SUPPORT_FUNCTION">
        <base-form-input
          label="N° Finess"
          type="text"
          controlName="finess"
          maxLength="9"
          [disabled]="form.get('finess')?.disabled"
          [hint]="
            !showFinessFields
              ? 'Pour renseigner le numéro FINESS, sélectionnez un type d\'activité associé à FINESS.'
              : ''
          "
        ></base-form-input>
      </ng-container>

      <!-- Section Adresses Multiples -->
      <div class="activity-addresses-section">
        <h4 class="mb-4 flex items-center">
          Adresses de l'activité
          <span *ngIf="showFinessFields" class="ml-2 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">
            FINESS : 1 adresse max
          </span>
        </h4>

        <div
          *ngFor="let addressControl of addressControls.controls; let i = index"
          [formGroup]="$any(addressControl)"
          class="address-item mb-4 p-4 border rounded"
        >
          <div class="flex justify-between items-center mb-2">
            <h5>Adresse {{ i + 1 }}</h5>
            <button
              *ngIf="addressControls.controls.length > 1"
              type="button"
              mat-icon-button
              color="warn"
              (click)="removeAddress(i)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <base-form-input
            label="Adresse"
            type="autocomplete"
            controlName="addressId"
            [items$]="getFilteredAddressesForIndex(i)"
            displayProperty="display"
            [autocompletePanelWidthAuto]="true"
            (autocompleteChange)="onAddressSearch($event, i)"
          ></base-form-input>

          <div *ngIf="candidateBuildings[i]?.length > 1" class="building-selection">
            <div class="building-selection__header">
              <mat-icon class="text-sm mr-1">info</mat-icon>
              <span>
                Cette adresse est liée à plusieurs bâtiments de l'établissement. Sélectionnez celui à utiliser.
              </span>
            </div>
            <mat-radio-group
              (change)="onCandidateBuildingSelected($event.value, i)"
              class="building-selection__options"
            >
              <mat-radio-button
                *ngFor="let building of candidateBuildings[i]"
                [value]="building"
                [checked]="isCandidateBuildingSelected(building, i)"
                class="building-selection__option"
              >
                <div class="flex flex-col">
                  <span class="font-medium">{{ building.label }}</span>
                  <span class="text-sm text-secondary">
                    Surface disponible : {{ getCandidateBuildingAvailableSurface(building) }} m²
                  </span>
                </div>
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <base-form-input label="Surface (m²)" type="number" controlName="surface"></base-form-input>

          <div *ngIf="shouldShowSurfaceInfo(i)" class="text-caption mt-2 text-blue-600">
            <mat-icon class="text-sm mr-1">info</mat-icon>
            Surface disponible :
            {{
              getAvailableSurface(i) !== undefined
                ? getAvailableSurface(i)
                : selectedBuildings[i].availableSurface?.toFixed(2)
            }}
            m²
          </div>
        </div>

        <button
          type="button"
          mat-stroked-button
          color="primary"
          (click)="addAddress()"
          [disabled]="!canAddAddress()"
          class="mt-2"
        >
          <mat-icon>add</mat-icon>
          Ajouter une adresse
        </button>

        <!-- Message d'information si limitation active -->
        <div *ngIf="!canAddAddress()" class="text-sm text-orange-600 mt-2 flex items-center">
          <mat-icon class="text-sm mr-1">info</mat-icon>
          {{ getAddressLimitMessage() }}
        </div>
      </div>

      <ng-container *ngIf="establishmentType !== EstablishmentTypeEnum.SUPPORT_FUNCTION && showFinessFields">
        <base-form-input
          label="Nombre de lits permanents"
          controlName="nbOfPermanantBed"
          type="number"
        ></base-form-input>
      </ng-container>

      <ng-container *ngIf="establishmentType !== EstablishmentTypeEnum.SUPPORT_FUNCTION && showFinessFields">
        <base-form-input
          label="Nombre de lits temporaires"
          controlName="nbOfTemporaryBed"
          type="number"
        ></base-form-input>
      </ng-container>

      <ng-container *ngIf="establishmentType !== EstablishmentTypeEnum.SUPPORT_FUNCTION && showFinessFields">
        <base-form-input label="Capacité d'accueil" controlName="accomodationCapacity" type="number"></base-form-input>
      </ng-container>

      <!-- Message d'erreur global pour la validation "au moins 1 champ" -->
      <div
        *ngIf="
          form.hasError('atLeastOneCapacityRequired') &&
          (form.get('nbOfPermanantBed')?.touched ||
            form.get('nbOfTemporaryBed')?.touched ||
            form.get('accomodationCapacity')?.touched)
        "
        style="
          color: #dc2626;
          font-weight: 600;
          background-color: #fef2f2;
          padding: 12px;
          border-radius: 4px;
          border-left: 4px solid #dc2626;
          margin-top: 8px;
          font-size: 14px;
        "
      >
        ⚠️ Au moins un des champs suivants doit être renseigné : Lits permanents, Lits temporaires ou Capacité d'accueil
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        [loading]="loading"
        type="submit"
        [mode]="mode"
        entityLabel="SUPPLIER"
        (onCreate)="createItem()"
        (onUpdate)="updateItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isArchiveMode()">
  <!-- Étape 1 : Vérification initiale -->
  <ng-container *ngIf="!isVerified">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
      <div>Archiver une activité</div>
      <button type="button" mat-icon-button (click)="close()" tabindex="-1">
        <mat-icon [icIcon]="icClose"></mat-icon>
      </button>
    </div>

    <mat-dialog-content>
      <p>
        Avant d'archiver cette activité, il est important de vérifier si elle est utilisée dans des bâtiments,
        équipements ou paniers en cours.
      </p>
      <p>Souhaitez-vous lancer cette vérification ?</p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="close()">ANNULER</button>
      <button mat-button color="primary" [loading]="loading" (click)="checkDependencies()">VÉRIFIER</button>
    </mat-dialog-actions>
  </ng-container>

  <!-- Étape 2 : Affichage des dépendances si trouvées -->
  <ng-container *ngIf="isVerified && hasDependencies">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
      <div>{{ canDelete ? 'Attention : cette activité est utilisée' : 'Archivage impossible' }}</div>
      <button type="button" mat-icon-button (click)="close()" tabindex="-1">
        <mat-icon [icIcon]="icClose"></mat-icon>
      </button>
    </div>

    <mat-dialog-content>
      <section class="card p-5 mb-4">
        <div *ngFor="let dep of dependencies?.data">
          <p
            *ngIf="dep.dependencies && dep.dependencies.length > 0"
            class="font-semibold text-lg text-gray-700 mt-4 mb-2"
          >
            {{ dep.name }}
            <span class="item-badge" fxFlex="none">
              {{ dep.dependencies.length }}
            </span>
          </p>
          <p>{{ dep.dependencies.join(', ') }}</p>
        </div>
      </section>

      <ng-container *ngIf="canDelete; else blockedByTickets">
        <p class="text-orange-600 font-medium mt-4">
          ⚠️ Si vous archivez cette activité, elle ne sera plus prise en compte dans ces éléments.
        </p>
        <p>Voulez-vous continuer ?</p>
      </ng-container>
      <ng-template #blockedByTickets>
        <p class="text-red-600 font-medium mt-4">
          ⚠️ Impossible d'archiver cette activité : des paniers en cours s'y réfèrent.
        </p>
        <p>Clôturez, abandonnez ou archivez ces paniers avant de réessayer.</p>
      </ng-template>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <ng-container *ngIf="canDelete; else closeOnly">
        <button mat-button (click)="close()">ANNULER</button>
        <button mat-button color="warn" [loading]="loading" (click)="confirmDelete()">ARCHIVER QUAND MÊME</button>
      </ng-container>
      <ng-template #closeOnly>
        <button mat-button (click)="close()">FERMER</button>
      </ng-template>
    </mat-dialog-actions>
  </ng-container>

  <!-- Étape 3 : Confirmation si aucune dépendance -->
  <ng-container *ngIf="isVerified && !hasDependencies">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
      <div>Confirmer l'archivage</div>
      <button type="button" mat-icon-button (click)="close()" tabindex="-1">
        <mat-icon [icIcon]="icClose"></mat-icon>
      </button>
    </div>

    <mat-dialog-content>
      <p>✓ Super, aucune dépendance n'a été trouvée.</p>
      <p>Souhaitez-vous confirmer l'archivage de cette activité ?</p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="close()">ANNULER</button>
      <button mat-button color="warn" [loading]="loading" (click)="confirmDelete()">ARCHIVER</button>
    </mat-dialog-actions>
  </ng-container>
</ng-container>
